'use client';

import React, { FC } from 'react';

import IconLucideBell from '@repo/ui-icons/IconLucideBell';
import { H2 } from '@repo/ui-kit/components/core/Typography';

import { FlexColumn, FlexRow } from 'styles/layouts';
import { HideDesktop, HideMobile } from 'styles/queries';

import { getSectionIcon } from '../iconUtils';
import { LandingButton } from '../landingButton';
import { MediaElement } from '../shared/mediaElement';
import { ComponentContainer, ComponentWrapper } from '../shared/styles';
import TextBlock from '../shared/TextBlock/TextBlock';

import { IconText, IconTextContainer, TextSection, Wrapper } from './styles';
import { ImageTextProps } from './types';

export const ImageText: FC<ImageTextProps> = ({
  title,
  description,
  button,
  imagePosition,
  media,
  benefitsList,
}) => {
  const analyticsMeta = {
    componentName: 'imageSection',
    title: title.slice(0, 25),
  };

  return (
    <ComponentWrapper>
      <ComponentContainer>
        <Wrapper>
          {imagePosition === 'right' && (
            <HideDesktop>
              <MediaElement {...media} aspectRatio="6/5" />
            </HideDesktop>
          )}
          {imagePosition === 'left' && (
            <MediaElement {...media} aspectRatio="6/5" />
          )}
          <TextSection>
            <FlexColumn gap="20px">
              <H2 bold>{title}</H2>
              {!!description && <TextBlock text={description} />}
            </FlexColumn>
            {!!button && (
              <LandingButton
                analyticsMeta={analyticsMeta}
                isSignUp={button.isSignUp}
                label={button.label}
                url={button.url}
              />
            )}
            {benefitsList && (
              <IconTextContainer>
                {benefitsList.map(({ text, icon }) => {
                  const Icon = icon
                    ? getSectionIcon(icon, IconLucideBell)!
                    : undefined;
                  return (
                    <FlexRow key={text} alignItems="center">
                      {!!Icon && <Icon color="var(--color-text)" />}
                      <IconText>{text}</IconText>
                    </FlexRow>
                  );
                })}
              </IconTextContainer>
            )}
          </TextSection>
          {imagePosition === 'right' && (
            <HideMobile>
              <MediaElement {...media} aspectRatio="6/5" />
            </HideMobile>
          )}
        </Wrapper>
      </ComponentContainer>
    </ComponentWrapper>
  );
};
